import Polygon from "ol/geom/Polygon"
import { SnapshotExtentData } from "../editor/project_editor"
import { GeoJSON } from "ol/format"

const polygonCache = new Map<string, Polygon[]>()

export async function getPolygonFromLayer(extentShape: SnapshotExtentData) : Promise<Polygon[]> {

    const id = JSON.stringify(extentShape)

    if(polygonCache.has(id)) {
        return polygonCache.get(id)!
    }

    const source = extentShape.externalLink ? extentShape.externalLink : "https://landscapes.wearepal.ai/geoserver/wfs?"
    const layer = extentShape.layer
    const cql = extentShape.cql

    const params = {
        outputFormat: 'application/json',
        request: 'GetFeature',
        typeName: layer,
        srsName: 'EPSG:3857',
        CQL_FILTER: cql
    }

    const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== undefined)
    );
    
    const response = await fetch(
        source + new URLSearchParams(filteredParams as Record<string, string>)
    )
    
    const polygons = new GeoJSON().readFeatures(await response.json()).map(feature => feature.getGeometry() as Polygon)
    polygonCache.set(id, polygons)
    return polygons
}